import * as Array2Obj from "./array2obj.js"
/**
 * 拼接抽屉数据权限
 * @param {*} drawerData 
 * @param {*} authorityData 所有权限数据
 * @param {*} isHead 是否是机构负责人
 */
export function initDrawerAuthorityData(drawerData, authorityData, isHead) {
    let dData = JSON.parse(JSON.stringify(drawerData))
    let authorityList = Array2Obj.Array2Obj(authorityData)

    // 是否为合同信息抽屉（特有核算成本/支出成本拆分字段），避免影响线索等其他抽屉中的 cost 字段
    let hasCostDoubleInput = false
    for (let index = 0; index < dData.data.modelList.length; index++) {
        for (let i = 0; i < dData.data.modelList[index].line.length; i++) {
            if (dData.data.modelList[index].line[i].key === "costDoubleInput") {
                hasCostDoubleInput = true
                break
            }
        }
        if (hasCostDoubleInput) {
            break
        }
    }

    for (let index = 0; index < dData.data.modelList.length; index++) {
        let modelItem = dData.data.modelList[index];
        for (let i = 0; i < modelItem.line.length; i++) {
            let line = modelItem.line[i];
            if (line.key) {
                line = changeAuthority(authorityList[line.key], line)
                if (isHead) {
                    // 是机构负责人  所有都可以修改
                    line.isShow = true
                    line.isDisable = false
                }
                // 合同信息抽屉：成本为核算成本与支出成本的合计，仅展示不可修改
                if (hasCostDoubleInput && line.key === "cost") {
                    line.isShow = true
                    line.isDisable = true
                }
            }

        }

    }
    return dData
}

function changeAuthority(authority, line) {
    switch (authority) {
        case 1:
        case "1":
            line.isShow = true
            line.isDisable = false
            break;
        case 2:
        case "2":
            line.isShow = true
            line.isDisable = true
            break;
        case 3:
        case "3":
            line.isShow = false
            line.isDisable = true
            break;
        case undefined:
            // 权限数据中不存在该字段，保持模板中定义的默认值（isShow/isDisable）
            break;
        default:
            line.isShow = false
            line.isDisable = true
            break;
    }
    return line
}

/**
 * 填充抽屉数据
 * @param {*} drawerData 
 * @param {*} data  数据库拿到的数据
 */
export function initDrawerData(drawerData, data) {
    
    let dData = JSON.parse(JSON.stringify(drawerData))
    let costSum = null
    for (let index = 0; index < dData.data.modelList.length; index++) {
        let modelItem = dData.data.modelList[index];
        for (let i = 0; i < modelItem.line.length; i++) {
            let line = modelItem.line[i];
            if (line.type == "doubleInput" && line.item) {
                for (let j = 0; j < line.item.length; j++) {
                    let sub = line.item[j];
                    if (sub.key) {
                        sub.value = data[sub.key]
                    }
                }
                // 成本 = 核算成本 + 支出成本
                if (line.key == "costDoubleInput") {
                    let sum = 0
                    let hasAny = false
                    for (let j = 0; j < line.item.length; j++) {
                        let sub = line.item[j];
                        if (
                            sub.key && sub.value !== null &&
                            sub.value !== "" && sub.value !== undefined
                        ) {
                            sum += parseFloat(sub.value) || 0
                            hasAny = true
                        }
                    }
                    if (hasAny) {
                        costSum = Math.round(sum * 100) / 100
                    }
                }
            } else if (line.key) {
                line.value = data[line.key]
            }
        }
    }
    // 将成本合计回填到成本展示字段
    if (costSum !== null) {
        for (let index = 0; index < dData.data.modelList.length; index++) {
            let modelItem = dData.data.modelList[index];
            for (let i = 0; i < modelItem.line.length; i++) {
                if (modelItem.line[i].key == "cost") {
                    modelItem.line[i].value = costSum
                }
            }
        }
    }
    return dData
}

/**
 * 获取当前属性的所有key数组
 * @param {*} authorityList
 */
export function getKeysByAuthorityList(authorityList) {
    let keys = []
    for (let index = 0; index < authorityList.length; index++) {
        let element = authorityList[index];
        keys.push(element.key)
    }
    return keys
}

/**
 * 在 authorityData 的 key 数组中追加模块标识（如 wechatApproval），已存在则不重复追加
 * @param {*} keys 原始 key 数组
 * @param {*} moduleKey 模块标识
 * @return {*} 追加后的 key 数组
 */
export function appendModuleKey(keys, moduleKey) {
    if (keys && keys.indexOf(moduleKey) < 0) {
        keys.push(moduleKey)
    }
    return keys
}